// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";

import { Colors } from "../../../assets/Colors";
import { fetchGet, fetchPost } from "../../../fetchers";
import { useMutation } from "@tanstack/react-query";
import { DynamicTableExtendFinance } from "../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import Button from "@material-tailwind/react/Button";
import "react-toastify/dist/ReactToastify.css";
import { maxPageGlobal } from "../../../assets/config";
import { useNavigate, useParams } from "react-router-dom";

const JurnalPage = ({}) => {
  const bisnisUnit = useMutation((formData) =>
    fetchGet("getMinMasterBisnisUnit")
  );

  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [detail, setDetail] = useState({});
  const [count, setCount] = useState(maxPageGlobal);
  const [start, setStart] = useState(0);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [param, setParam] = useState({
    start: start,
    count: count,
    search: "",
    BisnisUnitID: "U0002",
    Menu: "PC",
  });
  const params = useParams();

  // "Accounting" hanya mengembalikan jurnal yang BELUM disetujui (query-nya
  // menyaring Status != 1), sehingga halaman ini kosong begitu semua jurnal
  // sudah di-approve. "Accounting/All" query-nya identik tanpa filter status.
  const mutationData = useMutation((param) => fetchGet("Accounting/All"));
  const KirimTrans = useMutation((formData) =>
    fetchPost("Accounting/Kirim", formData)
  );

  const [showModalEdit, setShowModalEdit] = useState(false);

  useEffect(() => {
    mutationData.mutate();
  }, [KirimTrans.status]);

  useEffect(() => {
    bisnisUnit.mutate();
    mutationData.mutate();
  }, []);

  const editOpener = (detail) => {
    // AccountingID format baru mengandung slash — harus jadi dash dulu, kalau tidak
    // URL pecah jadi banyak segmen dan route ":transid" tak cocok (halaman blank).
    navigate(
      "/accounting/transaction/jurnal/" + String(detail ?? "").replaceAll("/", "-")
    );
  };

  const kirim = (detail) => {
    KirimTrans.mutate({ AccountingID: detail });
  };

  const header = [
    { name: "Jurnal ID", key: "AccountingID", modifiers: "Text" },
    { name: "Keterangan", key: "Keterangan", modifiers: "Text" },
    { name: "Tanggal", key: "Tanggal", modifiers: "Date" },
    { name: "Actions", key: "Edit", modifiers: "Button" },
    { name: "Status", key: "Status", modifiers: "Text" },
  ];

  const navigate = useNavigate();

  // Dulu memfilter `mutationData.data` sebagai array dan mencocokkan
  // `NamaKaryawan` — dua-duanya salah untuk data jurnal (responsnya envelope
  // {status,message,data}, dan tak ada kolom nama karyawan), jadi mengetik di
  // kotak cari melempar TypeError. Tak pernah terlihat selama tabel kosong.
  const filterData = (event) => {
    setSearch(event.target.value ?? "");
  };

  const rows = mutationData.data?.data ?? [];
  const keyword = search.trim().toLowerCase();
  const shownRows = (
    keyword === ""
      ? rows
      : rows.filter((row) =>
          [row.AccountingID, row.Keterangan].some((value) =>
            String(value ?? "")
              .toLowerCase()
              .includes(keyword)
          )
        )
  )
    // Salinan dulu — `sort` memutasi array aslinya (lihat bug mutasi state
    // yang pernah bikin hapus/edit list tak jalan). Terbaru di atas.
    .slice()
    .sort((a, b) => String(b.Tanggal ?? "").localeCompare(String(a.Tanggal ?? "")));

  const tableData = { ...(mutationData.data ?? {}), data: shownRows };

  const ModalOpener = (detail) => {
    navigate("/accounting/transaction/jurnal");
  };

  function handleUpdatePage(newPage) {
    let newStart = newPage * count - count;

    setParam({
      start: newStart,
      count: count,
      search: "",
      BisnisUnitID: param.bisnisUnitID,
      Menu: "PC",
    });
  }

  function handleUpdateCount(newCount) {
    let calc = count - 1;
    if (calc === 0) {
      calc = 1;
    }
    setParam({
      start: parseInt(newCount === "-1" ? 0 : start),
      count: parseInt(newCount === "-1" ? count : newCount),
      search: search,
      Menu: "PC",
      BisnisUnitID: param.bisnisUnitID,
    });
    setPage(newCount === "-1" ? 0 : start);
    setStart(newCount === "-1" ? count : newCount);
    setSearch(search);
    setPage(1);
    setCount(newCount === "-1" ? count : newCount);
    setStart(newCount === "-1" ? 0 : start);
    setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
  }

  function handleModal(value) {}

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col  content-center ">
                <DynamicTableExtendFinance
                  types="penerimaan-barang"
                  data={tableData}
                  header={header}
                  // Jurnal Approved sudah diposting ke "Accounting"/"AccountingList".
                  // UpdateAccounting memaksa Status kembali -1 tanpa memeriksa status
                  // awal, lalu approve ulang gagal di PK "Accounting" — buku besar
                  // tetap nilai lama sementara tabel transaksi sudah berubah.
                  hideEditStatus={["Approved"]}
                  menuController={filterData}
                  Master={true}
                  currentPage={page}
                  maxPage={maxPage}
                  name={"UserPC"}
                  OnClick={ModalOpener}
                  updateCount={handleUpdateCount}
                  count={count}
                  updatePage={handleUpdatePage}
                  modal={handleModal}
                  editor={editOpener}
                  kirim={kirim}
                  primarykey={"AccountingID"}
                  // cetakJurnal={true}
                />
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JurnalPage;
